import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { StorageService } from '../storage/storage.service';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private translate = inject(TranslateService);
  private storage = inject(StorageService);

  private readonly STORAGE_KEY = 'language';
  private readonly DEFAULT_LANG = 'es';
  private readonly AVAILABLE_LANGS = ['es', 'en'];

  /**
   * Inicializa el idioma de la aplicación
   * Primero intenta recuperar del storage, si no, usa español por defecto
   */
  initLanguage(): void {
    this.translate.addLangs(this.AVAILABLE_LANGS);
    this.translate.setFallbackLang(this.DEFAULT_LANG);

    const savedLang = this.storage.get<string>(this.STORAGE_KEY);

    if (savedLang && this.AVAILABLE_LANGS.includes(savedLang)) {
      this.translate.use(savedLang);
    } else {
      this.translate.use(this.DEFAULT_LANG);
    }
  }

  /**
   * Cambia el idioma actual y lo guarda en storage
   * @param lang Código del idioma a establecer
   */
  setLanguage(lang: string): void {
    if (this.AVAILABLE_LANGS.includes(lang)) {
      this.translate.use(lang);
      this.storage.set(this.STORAGE_KEY, lang);
    } else {
      console.warn(`Language ${lang} is not available.`);
    }
  }

  /**
   * Obtiene el idioma actual
   * @returns Código del idioma actual
   */
  getCurrentLang(): string {
    return this.translate.currentLang;
  }
}
